import { NSBaseServer } from "namirasoft-site";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { NamirasoftAccountHeader } from "./NamirasoftAccountHeader";
import { TokenManager } from "./TokenManager";
import { UserRow } from "./row/UserRow";
import { BaseServer, EnvService } from "namirasoft-core";

export abstract class NSABaseServer extends NSBaseServer
{
    static onBeforeRequest_SetToken<ReqData>(manager: TokenManager, config?: AxiosRequestConfig<ReqData>): void
    {
        let header = NamirasoftAccountHeader.req.TOKEN();
        let token = manager.getValue();
        if (token)
            if (config?.headers)
                config.headers[header] = token;
    }
    static onAfterRequest_SetUser<ResData>(manager: TokenManager, res: AxiosResponse<ResData, any>): void
    {
        let token = manager.getValue();
        if (token)
        {
            let header_user = NamirasoftAccountHeader.res.USER();
            let header_user_value = res.headers[header_user];
            if (header_user_value)
            {
                let user_value = atob(header_user_value);
                manager.setUser(JSON.parse(user_value) as UserRow);
            }
        }
    }
    public manager: TokenManager;
    public onError: (error: Error) => void
    constructor(domain: string, version: string, manager: TokenManager, onError: (erorr: Error) => void)
    {
        super(domain, version);
        this.manager = manager;
        this.onError = (error: Error) =>
        {
            if (BaseServer.isErrorCode(error, 401))
            {
                this.manager.del();
                let REACT_APP_BASE_URL_ACCOUNT_CONSOLE = new EnvService("REACT_APP_BASE_URL_ACCOUNT_CONSOLE", false).getString();
                if (REACT_APP_BASE_URL_ACCOUNT_CONSOLE)
                    window.location.href = REACT_APP_BASE_URL_ACCOUNT_CONSOLE;
            }
            onError(error);
        };

        this.NSAOnBeforeRequest = this.NSAOnBeforeRequest.bind(this);
        this.NSAOnAfterRequest = this.NSAOnAfterRequest.bind(this);

        this.addOnBeforeRequest(this.NSAOnBeforeRequest);
        this.addOnAfterRequest(this.NSAOnAfterRequest);
    }
    private NSAOnBeforeRequest<ReqData = any>(_: string, config?: AxiosRequestConfig<ReqData> | undefined): void
    {
        NSABaseServer.onBeforeRequest_SetToken(this.manager, config);
    }
    private NSAOnAfterRequest<ResData = any>(_: string, res: AxiosResponse<ResData, any>): void
    {
        NSABaseServer.onAfterRequest_SetUser(this.manager, res);
    }
};